export default {
  login: {
    error: {
      failed: 'Login failed. Check input values.',
    },
  },
}
